import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'

const DynamicPassengerField = ({key,data,index,name,onRemove}) => {
  console.log("name",name);
  return (
        <Box>
          <Card>
              <CardContent>
                        
                       <Typography variant="h5" component={"h1"}>{`${name.toUpperCase()}` } </Typography>
                       <Grid container>
                            
                       </Grid>
              </CardContent>

          </Card>
            
           
        </Box>
  )
}

export default DynamicPassengerField